import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { MiscService } from "app/shared/misc.service";
import { SESSION_USERTYPE } from "../_state/dashboard.interface";
import { environment } from "environments/environment";
import { retry } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ManagementService {
  private readonly REPORT_BASE_URL = `${environment.BASE_URL}/cmp-report`;
  private readonly AUTH_BASE_URL = `${environment.BASE_URL}/cmp-auth`;
  constructor(
    private http: HttpClient,
    private miscService: MiscService,
    private appLocalStorage: AppLocalStorage,
  ) { }

  fetchContinent = (currentPage?: number, pageSize?: number) => {
    let userData = this.miscService.getLoggedInUserDetails()?.data?.userType;
    let params = new HttpParams();
    if (currentPage) {
      params = params.append("page", currentPage);
    }
    if (pageSize) {
      params = params.append("limit", pageSize);
    }
    switch (userData) {
      case SESSION_USERTYPE.CONTINENTAL_ADMIN:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/countries`, {
            params,
          })
          .pipe(retry(2));

      case SESSION_USERTYPE.COUNTRY_ADMIN:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/allBranches`, {
            params,
          })
          .pipe(retry(2));
      case SESSION_USERTYPE.CHURCH_ADMIN:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/allArea`, {
            params,
          })
          .pipe(retry(2));
      case SESSION_USERTYPE.AREA_ADMIN:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/allDistrict`, {
            params,
          })
          .pipe(retry(2));
      case SESSION_USERTYPE.DISTRICT_ADMIN:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/allZones`, {
            params,
          })
          .pipe(retry(2));
      case SESSION_USERTYPE.ZONAL_ADMIN:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/allCell`, {
            params,
          })
          .pipe(retry(2));

      default:
        return this.http
          .get(`${environment.SERVER_URL}/management/country/continents`, {
            params,
          })
          .pipe(retry(2));
    }
  };

  createContinent = (data) =>
    this.http
      .post(`${environment.SERVER_URL}/management/country/add/continents`, data)
      .pipe(retry(2));

  createCountry = (data) =>
    this.http
      .post(`${environment.SERVER_URL}/management/country/add/country`, data)
      .pipe(retry(2));

  // assign pastor
  assignBranch = (data) =>
    this.http
      .put(`${this.AUTH_BASE_URL}/church/assign-branch`, data)
      .pipe(retry(2));

  assignArea = (data) =>
    this.http
      .put(`${this.AUTH_BASE_URL}/church/assign-area`, data)
      .pipe(retry(2));

  createPastor = (data) =>
    this.http
      .post(`${this.AUTH_BASE_URL}/user/registerWeb`, data)
      .pipe(retry(2));

  verifyPastor = (userId, isVerified) => {
    // const headers = new HttpHeaders()
    //   .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
    //   .set("Content-Type", "application/json");
    // let params = new HttpParams();
    // if (userId) {
    //   params = params.append("userId", userId);
    // }
    // if (isVerified) {
    //   params = params.append("isVerified", isVerified);
    // }
    return this.http
      .put(
        `${this.AUTH_BASE_URL}/user/verify-pastor?userId=${userId}&isVerified=${isVerified}`,
        {},
      )
      .pipe(retry(2));
  };

  fetchChurches = () =>
    this.http
      .get(`${environment.SERVER_URL}/management/country/allChurches`)
      .pipe(retry(2));

  allPastorDetail = () =>
    this.http
      .get(`${environment.SERVER_URL}/management/users/allPastorDetails`)
      .pipe(retry(2));

  getPastorById = (id) => {
    // let userData = this.miscService.getLoggedInUserDetails()?.data?.userType;
    // if (userData === SESSION_USERTYPE.ZONAL_ADMIN) {
    //   return this.http
    //     .get(`${environment.SERVER_URL}/auth/getWsfMinister/${id}`)
    //     .pipe(retry(2));
    // }

    return this.http
      .get(`${this.REPORT_BASE_URL}/user/getPastorById/${id}`)
      .pipe(retry(2));
  };

  getChurchesById = (id) => {
    let userData = this.miscService.getLoggedInUserDetails()?.data?.userType;
    // console.log(userData,1, id)
    // let userTypeValue = this.miscService.userTypeObj[userData.userType]
    switch (userData) {
      case SESSION_USERTYPE.CHURCH_ADMIN:
        return this.http
          .get(
            `${environment.SERVER_URL}/management/country/allChurchArea/${id}`,
          )
          .pipe(retry(2));

      case SESSION_USERTYPE.AREA_ADMIN:
        return this.http
          .get(
            `${environment.SERVER_URL}/management/country/allChurchDistrict/${id}`,
          )
          .pipe(retry(2));

      case SESSION_USERTYPE.DISTRICT_ADMIN:
        return this.http
          .get(
            `${environment.SERVER_URL}/management/country/allChurchZone/${id}`,
          )
          .pipe(retry(2));

      default:
        return this.http
          .get(
            `${environment.SERVER_URL}/management/country/allChurchBranches/${id}`,
          )
          .pipe(retry(2));
    }
  };

  //new implementation
  createBranch = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-branch`, payload);
  createArea = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-area`, payload);
  createHFC = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-hfc`, payload);

  fetchBranches = (page?: any, pageSize?: any, search?: any, state?: any) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/branchesAuth`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchserviceUnit = (page = "", pageSize = "") => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    return this.http
      .get(`${this.REPORT_BASE_URL}/user/list-serviceUnit`, {
        params,
      })
      .pipe(retry(2));
  };

  fetchprofession = (page = "", pageSize = "") => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    return this.http
      .get(`${this.REPORT_BASE_URL}/user/list-profession`, {
        params,
      })
      .pipe(retry(2));
  };

  fetchRoles = (page = "", pageSize = "") => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    params = params.append("source", "web");
    return this.http
      .get(`${this.REPORT_BASE_URL}/user/list-roles`, { headers, params })
      .pipe(retry(2));
  };

  fetchMetrics = (clusterId?: string) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (clusterId) {
      params = params.append("cluster", clusterId);
    }
    return this.http
      .get(`${this.REPORT_BASE_URL}/management/metrics`, { headers, params })
      .pipe(retry(2));
  };

  fetchUserTarget = (clusterId?: string) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (clusterId) {
      params = params.append("cluster", clusterId);
    }
    return this.http
      .get(`${this.REPORT_BASE_URL}/management/getChurchTarget`, { headers, params })
      .pipe(retry(2));
  };

  fetchAreas = (
    branch?: string,
    page?: number,
    pageSize?: number,
    search?: any,
    state?: any,
    d4r?: boolean,
    cluster?: string,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (d4r) {
      params = params.append("d4r", d4r);
    }
    if (cluster) {
      params = params.append("cluster", cluster);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/areasAuth`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchTemporalAreas = (
    temporaryChurchStatus?: string,
    branch?: string,
    page?: number,
    pageSize?: number,
    search?: any,
    state?: any,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (temporaryChurchStatus) {
      params = params.append("temporaryChurchStatus", temporaryChurchStatus);
    }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/temporary-area`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchHFC = (
    branch?: string,
    page?: number,
    pageSize?: number,
    search?: any,
    state?: any,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/hfcsAuth`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  createZone = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-zone`, payload);

  updateZoneById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-zone/${id}`,
      payload,
    );
  };

  updateTemporaryZoneById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-temporary-zone/${id}`,
      payload,
    );
  };

  fetchZones = (
    branch?: string,
    area?: string,
    page?: number,
    pageSize?: number,
    search?: any,
    state?: any,
    district?: string,
    d4r?: boolean,
    cluster?: string,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (district) {
      params = params.append("district", district);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (d4r) {
      params = params.append("d4r", d4r);
    }
    if (cluster) {
      params = params.append("cluster", cluster);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/zonesAuth`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };
  fetchTemporalZones = (
    temporaryChurchStatus: string,
    branch?: string,
    area?: string,
    page?: number,
    pageSize?: number,
    search?: any,
    state?: any,
    district?: string,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();

    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (district) {
      params = params.append("district", district);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (temporaryChurchStatus) {
      params = params.append("temporaryChurchStatus", temporaryChurchStatus);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/temporary-zones`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchZoneById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/zone/${id}`)
      .pipe(retry(2));
  };

  fetchTemporalZoneById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/temporary-zone/${id}`)
      .pipe(retry(2));
  };

  createDistrict = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-district`, payload);

  updateDistrictById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-district/${id}`,
      payload,
    );
  };

  fetchDistricts = (
    branch?: string,
    area?: string,
    page?: number,
    pageSize?: number,
    search?: any,
    state?: any,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/districtsAuth`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchDistrictById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/district/${id}`)
      .pipe(retry(2));
  };

  createCell = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-cell`, payload);

  updateCellById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-cell/${id}`,
      payload,
    );
  };
  updateTemporalCellById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-temporary-cell/${id}`,
      payload,
    );
  };

  fetchCells = (
    branch?: string,
    area?: string,
    zone?: string,
    page?: number,
    pageSize?: number,
    state?: any,
    search?: any,
    d4r?: boolean,
    has_minister?: boolean,
    cluster?: string,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (zone) {
      params = params.append("zone", zone);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (d4r) {
      params = params.append("d4r", d4r);
    }
    if (has_minister !== null && has_minister !== undefined) {
      params = params.append("has_minister", has_minister);
    }
    if (cluster) {
      params = params.append("cluster", cluster);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/cellsAuth`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchTemporalCells = (
    temporaryChurchStatus: string,
    branch?: string,
    area?: string,
    zone?: string,
    page?: number,
    pageSize?: number,
    state?: any,
    search?: any,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (zone) {
      params = params.append("zone", zone);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (temporaryChurchStatus) {
      params = params.append("temporaryChurchStatus", temporaryChurchStatus);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/temporary-cells`, {
        headers,
        params,
      })
      .pipe(retry(2));
  };

  fetchCellById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/cell/${id}`)
      .pipe(retry(2));
  };
  fetchTemporalCellById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/temporary-cell/${id}`)
      .pipe(retry(2));
  };
  fetchAllConverts = (
    branch?: string,
    area?: string,
    zone?: string,
    page?: number,
    pageSize?: number,
    download?: boolean,
  ) => {
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    let params = new HttpParams();
    let responseType;
    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (zone) {
      params = params.append("zone", zone);
    }
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (download) {
      params = params.append("download", download);
      responseType = "blob" as "json";
    }
    // if (search) {
    //   params = params.append("search", search);
    // }
    return this.http
      .get(`${this.REPORT_BASE_URL}/management/convert-for-church-records?`, {
        headers,
        params,
        responseType,
      })
      .pipe(retry(2));
  };
  /* fetchPastors = (page: any = "", pageSize: any = 0, role = "Pastor") => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (role) {
      params = params.append("name", role);
    }

    return this.http
      .get(`${environment.SERVER_URL}/user/list-users`, { params })
      .pipe(retry(2));
  }; */

  fetchPastors = (
    page: any = "",
    pageSize: any = 0,
    isVerified?: boolean,
    search?: string,
    state?: any,
    branch?: string,
    area?: string,
    zone?: string,
    cell?: string,
    role?: string,
    profession?: string,
    serviceUnit?: string,
  ) => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (isVerified !== null && isVerified !== undefined) {
      params = params.append("isVerified", isVerified);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    if (branch) {
      params = params.append("branch", branch);
    }
    if (area) {
      params = params.append("area", area);
    }
    if (zone) {
      params = params.append("zone", zone);
    }
    if (cell) {
      params = params.append("cell", cell);
    }
    if (role) {
      params = params.append("role", role);
    }
    if (profession) {
      params = params.append("profession", profession);
    }
    if (serviceUnit) {
      params = params.append("serviceUnit", serviceUnit);
    }

    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    return this.http
      .get(`${this.REPORT_BASE_URL}/user/list-pastors`, { headers, params })
      .pipe(retry(2));
  };

  fetchUsers = (
    page: any = "",
    pageSize: any = 0,
    isVerified?: boolean,
    search?: string,
    state?: any,
    branch?: string,
    area?: string,
    zone?: string,
    cell?: string,
    role?: string,
    profession?: string,
    serviceUnit?: string,
    country?: string,
  ) => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (isVerified !== null && isVerified !== undefined) {
      params = params.append("isVerified", isVerified);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    if (branch) {
      params = params.append("branchCode", branch);
    }
    if (area) {
      params = params.append("areaCode", area);
    }
    if (zone) {
      params = params.append("zoneCode", zone);
    }
    if (cell) {
      params = params.append("cellCode", cell);
    }
    if (role) {
      params = params.append("role", role);
    }
    if (profession) {
      params = params.append("profession", profession);
    }
    if (serviceUnit) {
      params = params.append("serviceUnit", serviceUnit);
    }

    if (country) {
      params = params.append("country", country);
    }

    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    return this.http
      .get(`${this.REPORT_BASE_URL}/user/list-users`, { headers, params })
      .pipe(retry(2));
    // return this.http.get(`${this.REPORT_BASE_URL}/user/list-users-test`, {headers, params}).pipe(retry(2));
  };

  fetchUsersV2 = (
    page: any = "",
    pageSize: any = 0,
    isVerified?: boolean,
    search?: string,
    state?: any,
    branch?: string,
    area?: string,
    zone?: string,
    cell?: string,
    role?: string,
    profession?: string,
    serviceUnit?: string,
    country?: string,
  ) => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (search) {
      params = params.append("search", search);
    }
    if (isVerified !== null && isVerified !== undefined) {
      params = params.append("isVerified", isVerified);
    }
    // if (state) {
    //   params = params.append("state", state);
    // }
    if (branch) {
      params = params.append("branchCode", branch);
    }
    if (area) {
      params = params.append("areaCode", area);
    }
    if (zone) {
      params = params.append("zoneCode", zone);
    }
    if (cell) {
      params = params.append("cellCode", cell);
    }
    if (role) {
      params = params.append("role", role);
    }
    if (profession) {
      params = params.append("profession", profession);
    }
    if (serviceUnit) {
      params = params.append("serviceUnit", serviceUnit);
    }

    if (country) {
      params = params.append("country", country);
    }

    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + this.appLocalStorage.getAccessToken())
      .set("Content-Type", "application/json");

    return this.http
      .get(`${this.REPORT_BASE_URL}/user/list-users-v2`, { headers, params })
      .pipe(retry(2));
    // return this.http.get(`${this.REPORT_BASE_URL}/user/list-users-test`, {headers, params}).pipe(retry(2));
  };

  deleteUserById = (id: string) => {
    return this.http
      .delete(`${this.AUTH_BASE_URL}/user/user/${id}`)
      .pipe(retry(2));
  };

  fetchBranchById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/branch/${id}`)
      .pipe(retry(2));
  };

  fetchAreaById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/area/${id}`)
      .pipe(retry(2));
  };

  fetchTemporalAreaById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/temporary-area/${id}`)
      .pipe(retry(2));
  };

  fetchHfcById = (id) => {
    return this.http
      .get(`${this.REPORT_BASE_URL}/church/hfc/${id}`)
      .pipe(retry(2));
  };

  updateHfcById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-hfc/${id}`,
      payload,
    );
  };
  updateAreaById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-area/${id}`,
      payload,
    );
  };

  updateTemporaryAreaById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-temporary-area/${id}`,
      payload,
    );
  };
  updateBranchById = (id, payload) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/update-branch/${id}`,
      payload,
    );
  };

  getInviteeDetails = (page, pageSize) => {
    let params = new HttpParams();
    if (page) {
      params = params.append("page", page);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    return this.http.get(
      `${this.REPORT_BASE_URL}/management/getInviteeDetails`,
      {
        params,
      },
    );
  };

  deleteBranchById = (id) =>
    this.http
      .delete(`${this.AUTH_BASE_URL}/church/branch/${id}`)
      .pipe(retry(2));

  deleteAreaById = (id) =>
    this.http.delete(`${this.AUTH_BASE_URL}/church/area/${id}`).pipe(retry(2));

  deleteHfcById = (id) =>
    this.http.delete(`${this.AUTH_BASE_URL}/church/hfc/${id}`).pipe(retry(2));

  deleteZoneById = (id) =>
    this.http.delete(`${this.AUTH_BASE_URL}/church/zone/${id}`).pipe(retry(2));

  deleteDistrictById = (id) =>
    this.http
      .delete(`${this.AUTH_BASE_URL}/church/district/${id}`)
      .pipe(retry(2));

  deleteCellById = (id) =>
    this.http.delete(`${this.AUTH_BASE_URL}/church/cell/${id}`).pipe(retry(2));

  unassignPastor = (payload) => {
    return this.http.post(
      `${this.AUTH_BASE_URL}/church/unassign-pastor`,
      payload,
    );
  };

  fetchAvailableContinent = () =>
    this.http
      .get(`${environment.SERVER_URL}/management/country/continents`)
      .pipe(retry(2));

  updateChopStatus(payload: {
    zones_status: { id: string; status: boolean }[];
  }) {
    return this.http.put(
      `${this.AUTH_BASE_URL}/church/zones/chop-status`,
      payload,
    );
  }

  updatePastorInformationWithCell = (userId: string, payload: any) => {
    return this.http.put(
      `${this.AUTH_BASE_URL}/v2/auth/update-cell/${userId}`,
      payload,
    );
  };

  // CLUSTER IMPLEMENTATION
  deleteClusterById = (id) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/delete-cluster/${id}`, {});

  getAllClusters = (page: number = 1, limit: number = 10) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/list-clusters`, { page, limit });

  createCluster = (payload) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/create-cluster`, payload);

  updateClusterById = (id, payload) =>
    this.http.post(
      `${this.AUTH_BASE_URL}/church/update-cluster/${id}`,
      payload,
    );

  getClusterById = (id) =>
    this.http.post(`${this.AUTH_BASE_URL}/church/get-cluster/${id}`, {});

  removePastorFromCluster = (
    pastorId: string | number,
    clusterId: string | number,
  ) =>
    this.http.post(
      `${this.AUTH_BASE_URL}/church/remove-pastor/${pastorId}?clusterId=${clusterId}`,
      {},
    );
}
